import { useState } from 'react';
import { FileText, Mail } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { DocumentTemplateTable } from '@/components/admin/templates/document/DocumentTemplateTable';
import { EmailTemplateTable } from '@/components/admin/templates/email/EmailTemplateTable';

export default function TemplatesPage() {
  const [activeTab, setActiveTab] = useState('document');

  return (
    <div className="py-6 px-6 space-y-6">
      <h1 className="text-2xl font-bold">Template Management</h1>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2 max-w-md">
          <TabsTrigger value="document" className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            Document Templates
          </TabsTrigger>
          <TabsTrigger value="email" className="flex items-center gap-2">
            <Mail className="h-4 w-4" />
            Email Templates
          </TabsTrigger>
        </TabsList>

        <TabsContent value="document" className="space-y-4">
          <DocumentTemplateTable />
        </TabsContent>

        <TabsContent value="email" className="space-y-4">
          <EmailTemplateTable />
        </TabsContent>
      </Tabs>
    </div>
  );
}
